module.exports = __webpack_public_path__ + "9c5a9dcee28c795d0bdaabb29fc735bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/whole_foods_2021_chart.png
// module id = 1759
// module chunks = 0